"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _Anchor = _interopRequireWildcard(require("./Anchor"));

var _classnames = _interopRequireDefault(require("classnames"));

"use strict";

/**
 * @enum {string}
 * @alias Link.iconColors
 */
var iconColors = {
  /** default */
  DEFAULT: "default",

  /** active */
  ACTIVE: "active"
};
/**
 * @class Link
 * @desc A stateless component for displaying a link
 *
 * @param {string} [className]
 *     CSS classes to be set on the inner Link container.
 * @param {string} [count]
 *          Count for Link
 * @param {string} [data-id="link"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {boolean} [disabled=false]
 *     Indicates whether component is disabled.
 * @param {string} [icon]
 *          Icon name for Link
 * @param {boolean} [iconAfter=false]
 *          When true, places icon after text.
 * @param {Link.iconColors} [iconColor]
 *          Changes the color for the icon.
 * @param {Link~onClick} [onClick]
 *     Callback to be triggered when Link selected.
 * @param {Anchor.linkSizes} [size=AUTO]
 *     Size of link. When AUTO, the size is determined by context.
 * @param {string} [target]
 *          Target for Link
 * @param {string} [title]
 *          title for Link
 * @param {Anchor.linkTypes} [type=REGULAR]
 *     Type of link
 * @param {string} [url]
 *          URL for Link
 *
 * @example
 * <Link
 *      title={this.state.title}
 *      icon={this.state.icon}
 *      count={this.state.count}
 *      url={this.state.url}
 *      disabled={this.state.disabled}
 *      onClick={this.state.onClick}
 * />
 *
 */

var Link = function Link(props) {
  var children = props.children,
      className = props.className,
      count = props.count,
      target = props.target,
      type = props.type,
      title = props.title,
      url = props.url,
      dataId = props["data-id"];
  var isNotBlock = type !== _Anchor.linkTypes.BLOCK;

  if ((children || type && isNotBlock) && !(title || count)) {
    return /*#__PURE__*/_react.default.createElement(_Anchor.default, (0, _extends2.default)({
      className: className,
      "data-id": dataId,
      href: url
    }, props));
  }

  var disabled = props.disabled,
      icon = props.icon,
      iconColor = props.iconColor,
      iconAfter = props.iconAfter,
      onClick = props.onClick;

  var _handleClick = function _handleClick(event) {
    if (!disabled && onClick) {
      onClick(event);
    }
  };

  var linkCss = (0, _classnames.default)(className, {
    disabled: disabled,
    "content-link--icon-color-active": iconColor === iconColors.ACTIVE,
    "text-first": iconAfter
  });

  var _renderTitle = function _renderTitle() {
    if (icon) {
      return /*#__PURE__*/_react.default.createElement(_Icon.default, {
        iconName: icon
      }, title);
    } else if (count) {
      return [/*#__PURE__*/_react.default.createElement("span", {
        className: "count",
        key: "count"
      }, count), title];
    } else {
      return title;
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    "data-id": dataId,
    className: "content-link"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: url,
    target: target,
    className: linkCss,
    "data-id": "link-anchor",
    onClick: _handleClick
  }, _renderTitle()));
};

Link.propTypes = {
  "data-id": _propTypes.default.string,
  icon: _propTypes.default.string,
  iconAfter: _propTypes.default.bool,
  count: _propTypes.default.string,
  url: _propTypes.default.string,
  target: _propTypes.default.string,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  type: _propTypes.default.oneOf((0, _values.default)(_Anchor.linkTypes)),
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  className: _propTypes.default.string
};
Link.defaultProps = {
  "data-id": "content-link",
  disabled: false,
  className: "",
  target: "_self",
  iconAfter: false
};
Link.linkSizes = _Anchor.linkSizes;
Link.linkTypes = _Anchor.linkTypes;
Link.iconColors = iconColors;
var _default = Link;
exports.default = _default;
module.exports = exports["default"];